import { ReactNode } from 'react';
import { exposeClassnames as classnames } from '@stadionhq-v3/utilities';
import { GatewayCardProps, Heading } from '@stadionhq-v3/base-ui';
import styles from './gatewayCard.module.scss';

export type GatewayCardWithBadgeProps = GatewayCardProps & {
  badge?: ReactNode;
};

const GatewayCard = ({
  title,
  subTitle,
  image,
  link,
  badge,
  nativeProps,
  classNames,
}: GatewayCardWithBadgeProps) => {
  const classes = classnames([styles.tokens, styles.gatewayCard], classNames);

  return (
    <article {...nativeProps} className={classes} data-component="GatewayCard">
      {image && (
        <div className={classnames(styles.backgroundImage)}>{image}</div>
      )}
      <div className={classnames(styles.topPanel)}>
        {badge && <div className={classnames(styles.badge)}>{badge}</div>}
      </div>

      <div className={classnames(styles.textPanel)}>
        <div className={classnames(styles.text)}>
          <div className={classnames(styles.titleContainer)}>
            <Heading as="h5" classNames={[classnames(styles.title)]}>
              {title}
            </Heading>
            {subTitle && (
              <span className={classnames(styles.subTitle)}>{subTitle}</span>
            )}
          </div>
        </div>
      </div>

      {link && (
        <a href={link.url} className={classnames(styles.floatingLink)}>
          <span>{link.title}</span>
        </a>
      )}
    </article>
  );
};

export default GatewayCard;
